module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "vue-tables-options"
    }
  }, [_c('v-client-table', {
    staticClass: "hydroware-table",
    attrs: {
      "data": _vm.myController.incidents,
      "columns": _vm.myController.compliance_columns,
      "options": _vm.myController.optionstable
    },
    scopedSlots: _vm._u([{
      key: "IncidentDate",
      fn: function(props) {
        return [_vm._v("\n                      " + _vm._s(_vm._f("fdate")(props.row.IncidentDate)) + "\n                    ")]
      }
    }, {
      key: "Actions",
      fn: function(props) {
        return [_c('div', [_c('hydroware-viewOrEdit-button', {
          attrs: {
            "EV": _vm.$hydrowareSecurityJS.showViewOrEditOrNeitherButton_A('incidents')
          },
          on: {
            "click": function($event) {
              return _vm.myController.editcol(props)
            }
          }
        }), _vm._v(" "), (_vm.$hydrowareSecurityJS.canDelete_A('incidents')) ? _c('hydroware-delete-button', {
          on: {
            "click": function($event) {
              return _vm.myController.del(props)
            }
          }
        }) : _vm._e()], 1)]
      }
    }])
  }, [(_vm.$hydrowareSecurityJS.canAdd_A('incidents')) ? _c('hydroware-add-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.myController.isediting),
      expression: "!myController.isediting"
    }],
    attrs: {
      "slot": "afterLimit"
    },
    on: {
      "click": function($event) {
        return _vm.myController.addCompliancevit()
      }
    },
    slot: "afterLimit"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10036943"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HealthSafety/IncidentAccident/incidentAndAccidentTable.vue
// module id = 770
// module chunks = 1